import { useParams, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import "./playerMenu.scss";

import { useDispatch, useSelector } from "react-redux";
import { pkClear, reset } from "../../../../../store/reducers/reducerUser";

import { checkClass } from "../../../../tools/checkClass";
import Scrollto from "../../../../tools/scrollTo";
import PanelFrame from "../../../../ui/PanelFrame";
import SiteButton from "../../../../ui/SiteButton";
import { useLang } from "../../../../../i18n/LangContext";

const PlayerMenu = () => {
  const dispatch = useDispatch();
  const { t } = useLang();
  const player = useSelector((state) => state.reducerUser.userLogin.data);
  const params = useParams();
  const navigate = useNavigate();

  const selected = useMemo(() => {
    const list = player?.data?.[1]?.players;
    if (!Array.isArray(list)) return null;
    return list.find((p) => p.Name === params.id) || null;
  }, [player, params.id]);

  const isGm = selected && Number(selected.CtlCode) === 32;

  return (
    <div className="mu-player-menu">
      <Scrollto position={200} />

      <div className="mu-player-menu__toolbar">
        <button
          type="button"
          className="mu-player-menu__back"
          onClick={() => navigate("/players")}
        >
          {t("back_to_characters")}
        </button>
      </div>

      <PanelFrame title={t("character_options")} className="mu-player-menu__frame">
        {selected ? (
          <div className="mu-player-menu__hero">
            <span
              className={`mu-player-menu__badge${
                isGm ? " mu-player-menu__badge--gm" : ""
              }`}
            >
              {isGm ? t("game_master") : t("player")}
            </span>
            <img
              className="mu-player-menu__avatar"
              src={checkClass(selected.Class)}
              alt=""
            />
            <h3 className="mu-player-menu__name">{selected.Name}</h3>
            <p className="mu-player-menu__meta">
              {t("level_resets", {
                level: selected.cLevel,
                resets: selected.Reset ?? 0,
              })}
            </p>
          </div>
        ) : (
          <p className="mu-player-menu__empty">{t("character_not_found")}</p>
        )}

        <div className="mu-player-menu__actions">
          <SiteButton
            variant="primary"
            to={`/player/addStats/${params.id}`}
            className="mu-player-menu__action"
          >
            {t("add_stats")}
          </SiteButton>

          <SiteButton
            variant="secondary"
            className="mu-player-menu__action"
            onClick={() =>
              dispatch(
                reset({ username: player.username, name: params.id })
              )
            }
          >
            {t("reset_character")}
          </SiteButton>

          <SiteButton
            variant="secondary"
            className="mu-player-menu__action"
            onClick={() =>
              dispatch(
                pkClear({ username: player.username, name: params.id })
              )
            }
          >
            {t("clear_pk")}
          </SiteButton>

          <SiteButton
            variant="ghost"
            to="/buyCredits"
            className="mu-player-menu__action"
          >
            {t("buy_bcoin")}
          </SiteButton>
        </div>
      </PanelFrame>
    </div>
  );
};

export default PlayerMenu;
